import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';
import { spotFinder } from './endpoints';

export const labourOfficialWorkApi = createApi({
  reducerPath: 'labourOfficialWorkApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['labourOfficialWorkApi'],
  endpoints: (builder) => ({
    getAllLabourOfficialWorks: builder.mutation({
      query(body) {
        return {
          url: spotFinder.labourOfficialWorkController.getAllLabourOfficialWorks,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    getLabourOfficialWorkById: builder.mutation({
      query(body) {
        console.log("body:",body);
        return {
          url: `${spotFinder.labourOfficialWorkController.getLabourOfficialWorkById}${body.id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    createLabourOfficialWork: builder.mutation({
        query(body) {
            return {
              url: body.payload.isEdit
                ? `${spotFinder.labourOfficialWorkController.updateLabourOfficialWork}${body.payload.id}` 
                : spotFinder.labourOfficialWorkController.createLabourOfficialWork, 
              method: body.payload.isEdit ? 'PUT' : 'POST',
              headers: { Authorization: `Bearer ${body.token}` }, 
              body: body.payload, // Pass the payload as the body
            };
          },
      }),
      updateLabourOfficialWork: builder.mutation({
      query(body) {
        return {
          url: body.payload.isEdit
            ? `${spotFinder.labourOfficialWorkController.updateLabourOfficialWork}${body.payload.id}`
            : spotFinder.labourOfficialWorkController.createLabourOfficialWork,
          method: body.payload.isEdit ? 'PUT' : 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});


export const {
  useUpdateLabourOfficialWorkMutation,
  useGetAllLabourOfficialWorksMutation,
  useCreateLabourOfficialWorkMutation,
  useGetLabourOfficialWorkByIdMutation,
} = labourOfficialWorkApi;
